import React, {
  useMemo,
  useState,
} from "react";

// ============================================================
// LISTA GENERAL DE PERMISOS SIGEDI
// ============================================================

const TODOS_LOS_PERMISOS = [
  "Certificados Clase SA","cambio los destinos de todos","veo estadistica de procesos",
  "CertificadosJustifica Inasistencia",
  "Pase Salida Grupal",
  "Veo inasistencia docente",
  "Veo informe pases",
  "Veo quien marco",
  "DG",
  "Reclama Sancion",
  "Certificados",
  "Subdirector EP",
  "Director EP",
  "Veo Legajo Virtual",
  "Carga Guardias",
  "Veo Cambios Condicion",
  "Completo Reconocimientos",
  "Jefe de Servicio",
  "Reempadrona",
  "Crea Pases",
  "Cuerpo",
  "Gestiona Docentes",
  "Cambio Docente",
  "Borro Materia",
  "Estudio",
  "Gestion Horas Docentes",
  "Veo Inasistencias",
  "Sanidad",
  "Crea Reconocimientos",
  "Confirma Sancion",
  "Notificaciones",
  "Direccion",
  "Condono Inasistencias",
  "Veo Documentacion Medica",
  "Carga Documentacion Medica",
  "Gestion de Calificaciones",
  "Veo Postulantes Convocados",
  "Veo Procesos de Ingreso",
  "Titulos",
  "Veo Todo Certificados",
  "Elimina Documentacion Medica",
  "Elijo Ver Sanciones Legajo Virtual",
  "Educacion a Distancia",
  "Escuela de Especialidades",
  "Escuela de Policia",
  "Escuela de Investigaciones",
  "Escuela Superior",
  "Cambio condicion cadete",
  "DTyD",
  "Edita datos cadete",
  "Descargo Nomina Docente con horas vigentes",
  "veo estadistica Proceso",
  "veo todos los expedientes",
  "Procesos",
  "Inscripciones",
  "Justifica Inasistencia",
  "Busco Docentes",
  "Descargo Legajos Masivos",
  "Horas Escuela de Policia",
  "Puedo Editar Docente",
  "Subo Documentacion Ofrecimiento",
  "Borro del curso Materia",
  "Subo Resolucion Firmada",
  "Resoluciones DG",
  "Vacio Cursantes",
  "Asigno Cadete a Seccion",
  "Veo Documentacion Ofrecimiento",
  "Veo todas las escuelas Crear Cursos",
  "Horas Extracurricular",
  "Creo alulas moodle",
  "Gabinete Psico",
  "suspendo alumno",
  "Gestiono Usuarios Mi ISeP",
  "Horas Educacion a Distancia",
  "Horas Escuela de Investigaciones",
  "Horas Escuela de Especialidades",
  "Horas Escuela Superior",
  "Horas Extencion Comunitaria",
  "Horas Extension Comunitaria",
  "Veo Alumnos Mi ISeP",
  "Matriculo Manual Moodle",
  "Borro Alumno",
  "Extracurricular",
  "Extension Comunitaria",
  "Descargo Inasistencias Escuela",
  "Rematriculo Alumnos del Listado",
  "Resoluciones",
  "Informe Docentes Plataforma",
  "Sincronizo Moodle Docente",
  "Veo Procesos Sanidad",
  "Completo Procesos Sanidad",
  "Veo Documentos Procesos Sanidad",
  "Completo Procesos Psicologia",
  "Veo Documentos Procesos Psicologia",
  "Subo Archivos Psicologia",
  "Borro Archivos Postulante",
  "Veo Control Qr",
  "Subo Documentos Expedientes",
  "Veo Archivos Expedientes",
  "Veo Estado Calificaciones",
  "Importar Moodle Sigedi",
  "Descargo Expedientes",  "racionamiento",
  "Crea Incumbencia","veo datos sanidad","Veo Estadisticas Expedientes","Modifico Incumbencias al Docente","Veo Informe Incumbencias"
];

// ============================================================
// NORMALIZACIÓN
// ============================================================

const convertirArray = (
  valor
) => {
  if (!valor) {
    return [];
  }

  if (
    Array.isArray(valor)
  ) {
    return [
      ...new Set(
        valor
          .map((item) =>
            String(item).trim()
          )
          .filter(Boolean)
      ),
    ];
  }

  return [
    ...new Set(
      String(valor)
        .split(",")
        .map((item) =>
          item.trim()
        )
        .filter(Boolean)
    ),
  ];
};

// ============================================================
// AGRUPAR PERMISOS
// ============================================================

const obtenerCategoria = (
  permiso
) => {
  const texto =
    permiso.toLowerCase();

  if (
    texto.includes(
      "moodle"
    ) ||
    texto.includes(
      "curso"
    ) ||
    texto.includes(
      "alumnos"
    ) ||
    texto.includes(
      "cursantes"
    )
  ) {
    return "Moodle y aulas";
  }

  if (
    texto.includes(
      "docente"
    ) ||
    texto.includes(
      "horas"
    )
  ) {
    return "Docentes";
  }

  if (
    texto.includes(
      "sanidad"
    ) ||
    texto.includes(
      "psico"
    ) ||
    texto.includes(
      "documentacion medica"
    )
  ) {
    return "Sanidad y Psicología";
  }

  if (
    texto.includes(
      "cadete"
    ) ||
    texto.includes(
      "sancion"
    ) ||
    texto.includes(
      "inasistencia"
    ) ||
    texto.includes(
      "guardias"
    ) ||
    texto.includes(
      "pase"
    )
  ) {
    return "Cadetes";
  }

  if (
    texto.includes(
      "certificado"
    ) ||
    texto.includes(
      "titulo"
    )
  ) {
    return "Certificados y títulos";
  }

  if (
    texto.includes(
      "proceso"
    ) ||
    texto.includes(
      "inscripcion"
    ) ||
    texto.includes(
      "postulante"
    )
  ) {
    return "Procesos e ingreso";
  }

  if (
    texto.includes(
      "resolucion"
    ) ||
    texto.includes(
      "expediente"
    )
  ) {
    return "Expedientes y resoluciones";
  }

  if (
    texto.includes(
      "escuela"
    ) ||
    texto.includes(
      "educacion a distancia"
    ) ||
    texto.includes(
      "extracurricular"
    ) ||
    texto.includes(
      "extension comunitaria"
    )
  ) {
    return "Escuelas y dependencias";
  }

  return "Otros permisos";
};

// ============================================================
// COMPONENTE
// ============================================================

function Permisos({
  value = "",
  onChange,
  permisosPermitidos = null,
  permisosProtegidos = [],
  esSuperUsuario = false,
}) {
  const [
    busqueda,
    setBusqueda,
  ] = useState("");

  const [
    categoriaAbierta,
    setCategoriaAbierta,
  ] = useState({});

  // ==========================================================
  // SELECCIONADOS
  // ==========================================================

  const seleccionados =
    useMemo(() => {
      return convertirArray(
        value
      );
    }, [
      value,
    ]);

  // ==========================================================
  // PERMITIDOS
  //
  // null = todos
  // ==========================================================

  const permitidos =
    useMemo(() => {
      // ========================================================
      // REGLA DE DELEGACIÓN
      //
      // - Super Usuario: puede administrar todos los permisos.
      // - Resto: SOLAMENTE puede administrar los permisos que
      //   recibe en permisosPermitidos (sus propios permisos).
      //
      // IMPORTANTE:
      // antes "null" también significaba acceso total. Eso podía
      // habilitar permisos por error si el padre no enviaba la
      // prop. Ahora null/undefined para un usuario común equivale
      // a "ningún permiso delegable".
      // ========================================================

      if (esSuperUsuario) {
        return null;
      }

      return convertirArray(
        permisosPermitidos
      );
    }, [
      esSuperUsuario,
      permisosPermitidos,
    ]);

  // ==========================================================
  // PERMISOS PROTEGIDOS REALES
  // ==========================================================
  //
  // Para un usuario que NO es Super Usuario, todo permiso que el
  // usuario editado ya tenga pero que el administrador actual NO
  // posea queda automáticamente protegido.
  //
  // Esto evita dos cosas:
  // 1. que pueda agregar permisos que no tiene;
  // 2. que pueda quitar permisos que no tiene.
  //
  // También unimos los permisosProtegidos recibidos por props
  // para mantener compatibilidad con el componente padre.
  // ==========================================================

  const permisosProtegidosReales =
    useMemo(() => {
      if (esSuperUsuario) {
        return [];
      }

      const permitidosSet =
        new Set(permitidos || []);

      const detectados =
        seleccionados.filter(
          (permiso) =>
            !permitidosSet.has(
              permiso
            )
        );

      return [
        ...new Set([
          ...detectados,
          ...convertirArray(
            permisosProtegidos
          ),
        ]),
      ];
    }, [
      esSuperUsuario,
      permitidos,
      seleccionados,
      permisosProtegidos,
    ]);

  // ==========================================================
  // LISTA A MOSTRAR
  //
  // También agregamos permisos existentes
  // que quizás todavía no estén en la constante.
  // ==========================================================

  const todosLosPermisos =
    useMemo(() => {
      return [
        ...new Set([
          ...TODOS_LOS_PERMISOS,

          ...seleccionados,

          ...(permitidos ||
            []),

          ...permisosProtegidosReales,
        ]),
      ].sort(
        (a, b) =>
          a.localeCompare(
            b,
            "es",
            {
              sensitivity:
                "base",
            }
          )
      );
    }, [
      seleccionados,
      permitidos,
      permisosProtegidosReales,
    ]);

  // ==========================================================
  // PERMISOS EDITABLES
  // ==========================================================

  const permisosVisibles =
    useMemo(() => {
      let lista =
        todosLosPermisos;

      // NIVEL 2:
      // solamente los que posee
      if (
        permitidos !==
        null
      ) {
        lista =
          lista.filter(
            (permiso) =>
              permitidos.includes(
                permiso
              )
          );
      }

      if (
        busqueda.trim()
      ) {
        const texto =
          busqueda
            .trim()
            .toLowerCase();

        lista =
          lista.filter(
            (permiso) =>
              permiso
                .toLowerCase()
                .includes(
                  texto
                )
          );
      }

      return lista;
    }, [
      todosLosPermisos,
      permitidos,
      busqueda,
    ]);

  // ==========================================================
  // AGRUPADOS
  // ==========================================================

  const grupos =
    useMemo(() => {
      const resultado =
        {};

      permisosVisibles.forEach(
        (permiso) => {
          const categoria =
            obtenerCategoria(
              permiso
            );

          if (
            !resultado[
              categoria
            ]
          ) {
            resultado[
              categoria
            ] = [];
          }

          resultado[
            categoria
          ].push(
            permiso
          );
        }
      );

      return Object.entries(
        resultado
      ).sort(
        ([a], [b]) =>
          a.localeCompare(
            b,
            "es"
          )
      );
    }, [
      permisosVisibles,
    ]);

  // ==========================================================
  // TOGGLE
  // ==========================================================

  const togglePermiso = (
    permiso
  ) => {
    // ========================================================
    // BLOQUEO REAL DE PERMISOS NO DELEGABLES
    // ========================================================
    //
    // Aunque por UI no deberían aparecer, también bloqueamos
    // la función para que un permiso no autorizado no pueda ser
    // agregado o quitado accidentalmente.
    // ========================================================

    if (
      !esSuperUsuario &&
      !permitidos?.includes(
        permiso
      )
    ) {
      console.warn(
        "🔒 Permiso no delegable:",
        permiso
      );
      return;
    }

    const protegidosSet =
      new Set(
        permisosProtegidosReales
      );

    // Los permisos protegidos SIEMPRE se conservan.
    const editablesActuales =
      seleccionados.filter(
        (item) =>
          !protegidosSet.has(
            item
          )
      );

    let editablesNuevos;

    if (
      editablesActuales.includes(
        permiso
      )
    ) {
      editablesNuevos =
        editablesActuales.filter(
          (item) =>
            item !==
            permiso
        );
    } else {
      editablesNuevos = [
        ...editablesActuales,
        permiso,
      ];
    }

    const nuevos = [
      ...new Set([
        ...permisosProtegidosReales,
        ...editablesNuevos,
      ]),
    ];

    if (
      typeof onChange ===
      "function"
    ) {
      onChange(
        nuevos.join(",")
      );
    }
  };

  // ==========================================================
  // SELECCIONAR TODOS LOS VISIBLES
  // ==========================================================

  const seleccionarTodos =
    () => {
      const nuevos = [
        ...new Set([
          ...permisosProtegidosReales,
          ...seleccionados,
          ...permisosVisibles,
        ]),
      ];

      onChange?.(
        nuevos.join(",")
      );
    };

  // ==========================================================
  // QUITAR TODOS LOS EDITABLES
  //
  // NO TOCA permisos que el admin no puede administrar
  // porque esos ni siquiera llegan a permisosVisibles.
  // ==========================================================

  const quitarTodos =
    () => {
      const visibles =
        new Set(
          permisosVisibles
        );

      // Quitamos solamente permisos que este administrador puede
      // administrar. Los protegidos se preservan siempre.
      const nuevos = [
        ...new Set([
          ...permisosProtegidosReales,
          ...seleccionados.filter(
            (permiso) =>
              !visibles.has(
                permiso
              ) &&
              !permisosProtegidosReales.includes(
                permiso
              )
          ),
        ]),
      ];

      onChange?.(
        nuevos.join(",")
      );
    };

  // ==========================================================
  // TOGGLE CATEGORÍA
  // ==========================================================

  const toggleCategoria = (
    categoria
  ) => {
    setCategoriaAbierta(
      (actual) => ({
        ...actual,

        [categoria]:
          actual[
            categoria
          ] === false,
      })
    );
  };

  const categoriaEstaAbierta =
    (categoria) => {
      return (
        categoriaAbierta[
          categoria
        ] !== false
      );
    };

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <div>
      {/* ======================================================
          CABECERA
      ====================================================== */}

      <div
        style={{
          background:
            "#f8fafc",

          border:
            "1px solid #e2e8f0",

          borderRadius:
            "12px",

          padding:
            "14px",

          marginBottom:
            "15px",
        }}
      >
        <div
          style={{
            display:
              "flex",

            justifyContent:
              "space-between",

            alignItems:
              "center",

            gap:
              "10px",

            flexWrap:
              "wrap",
          }}
        >
          <div>
            <div
              style={{
                fontWeight:
                  700,

                color:
                  "#334155",
              }}
            >
              Permisos delegables
            </div>

            <div
              style={{
                color:
                  "#64748b",

                fontSize:
                  "12px",

                marginTop:
                  "3px",
              }}
            >
              {esSuperUsuario
                ? "Super Usuario: puede administrar todos los permisos."
                : `Puede delegar únicamente ${permitidos.length} permisos que posee en su propia cuenta.`}
            </div>
          </div>

          <div
            style={{
              display:
                "flex",

              gap:
                "7px",

              flexWrap:
                "wrap",
            }}
          >
            <button
              type="button"

              className="btn btn-outline-primary btn-sm"

              onClick={
                seleccionarTodos
              }
            >
              Seleccionar visibles
            </button>

            <button
              type="button"

              className="btn btn-outline-secondary btn-sm"

              onClick={
                quitarTodos
              }
            >
              Quitar visibles
            </button>
          </div>
        </div>

        {/* BUSCADOR */}

        <input
          type="text"

          value={
            busqueda
          }

          onChange={(e) =>
            setBusqueda(
              e.target.value
            )
          }

          placeholder="Buscar permiso..."

          style={{
            width:
              "100%",

            marginTop:
              "12px",

            minHeight:
              "42px",

            padding:
              "8px 12px",

            border:
              "1px solid #cbd5e1",

            borderRadius:
              "9px",
          }}
        />
      </div>

      {/* ======================================================
          RESUMEN
      ====================================================== */}

      <div
        style={{
          display:
            "flex",

          gap:
            "8px",

          flexWrap:
            "wrap",

          marginBottom:
            "15px",
        }}
      >
        <span
          className="badge bg-primary"
          style={{
            padding:
              "8px 10px",
          }}
        >
          {
            seleccionados.length
          }{" "}
          seleccionados
        </span>

        <span
          className="badge bg-secondary"
          style={{
            padding:
              "8px 10px",
          }}
        >
          {
            permisosVisibles.length
          }{" "}
          delegables
        </span>

        {permisosProtegidosReales.length > 0 && (
          <span
            className="badge bg-warning text-dark"
            style={{
              padding:
                "8px 10px",
            }}
          >
            {
              permisosProtegidosReales.length
            }{" "}
            protegidos
          </span>
        )}
      </div>

      {/* ======================================================
          PERMISOS PROTEGIDOS
      ====================================================== */}

      {permisosProtegidosReales.length > 0 && (
        <div
          style={{
            background:
              "#fff7ed",

            border:
              "1px solid #fed7aa",

            borderRadius:
              "10px",

            padding:
              "12px",

            marginBottom:
              "15px",
          }}
        >
          <div
            style={{
              fontWeight:
                700,

              color:
                "#9a3412",

              marginBottom:
                "5px",
            }}
          >
            🔒 Permisos protegidos
          </div>

          <div
            style={{
              color:
                "#64748b",

              fontSize:
                "12px",
            }}
          >
            Este usuario ya posee permisos
            que usted no tiene. No puede
            agregarlos ni quitarlos y se
            conservarán al guardar.
          </div>

          <div
            style={{
              display:
                "flex",

              gap:
                "5px",

              flexWrap:
                "wrap",

              marginTop:
                "9px",
            }}
          >
            {permisosProtegidosReales.map(
              (permiso) => (
                <span
                  key={
                    permiso
                  }

                  style={{
                    padding:
                      "4px 7px",

                    borderRadius:
                      "7px",

                    background:
                      "#fff",

                    border:
                      "1px solid #fed7aa",

                    color:
                      "#9a3412",

                    fontSize:
                      "11px",
                  }}
                >
                  🔒 {permiso}
                </span>
              )
            )}
          </div>
        </div>
      )}

      {/* ======================================================
          GRUPOS
      ====================================================== */}

      {grupos.length ===
      0 ? (
        <div
          style={{
            padding:
              "25px",

            textAlign:
              "center",

            color:
              "#64748b",

            background:
              "#f8fafc",

            borderRadius:
              "10px",
          }}
        >
          No hay permisos que coincidan con
          la búsqueda.
        </div>
      ) : (
        grupos.map(
          ([
            categoria,
            lista,
          ]) => (
            <div
              key={
                categoria
              }

              style={{
                border:
                  "1px solid #e2e8f0",

                borderRadius:
                  "11px",

                overflow:
                  "hidden",

                marginBottom:
                  "10px",
              }}
            >
              {/* CABECERA GRUPO */}

              <div
                onClick={() =>
                  toggleCategoria(
                    categoria
                  )
                }

                style={{
                  background:
                    "#f8fafc",

                  padding:
                    "11px 14px",

                  display:
                    "flex",

                  justifyContent:
                    "space-between",

                  alignItems:
                    "center",

                  cursor:
                    "pointer",

                  userSelect:
                    "none",
                }}
              >
                <strong
                  style={{
                    color:
                      "#334155",
                  }}
                >
                  {categoria}
                </strong>

                <div
                  style={{
                    display:
                      "flex",

                    alignItems:
                      "center",

                    gap:
                      "8px",
                  }}
                >
                  <span className="badge bg-secondary">
                    {
                      lista.length
                    }
                  </span>

                  <span>
                    {categoriaEstaAbierta(
                      categoria
                    )
                      ? "▲"
                      : "▼"}
                  </span>
                </div>
              </div>

              {/* OPCIONES */}

              {categoriaEstaAbierta(
                categoria
              ) && (
                <div
                  style={{
                    padding:
                      "12px",

                    display:
                      "grid",

                    gridTemplateColumns:
                      "repeat(auto-fit,minmax(260px,1fr))",

                    gap:
                      "8px",
                  }}
                >
                  {lista.map(
                    (
                      permiso
                    ) => {
                      const activo =
                        seleccionados.includes(
                          permiso
                        );

                      return (
                        <label
                          key={
                            permiso
                          }

                          style={{
                            display:
                              "flex",

                            alignItems:
                              "center",

                            gap:
                              "9px",

                            padding:
                              "10px",

                            border:
                              activo
                                ? "1px solid #2563eb"
                                : "1px solid #e2e8f0",

                            borderRadius:
                              "9px",

                            background:
                              activo
                                ? "#eff6ff"
                                : "#fff",

                            cursor:
                              "pointer",

                            transition:
                              "all .12s ease",
                          }}
                        >
                          <input
                            type="checkbox"

                            checked={
                              activo
                            }

                            onChange={() =>
                              togglePermiso(
                                permiso
                              )
                            }
                          />

                          <span
                            style={{
                              fontSize:
                                "13px",

                              color:
                                activo
                                  ? "#1e40af"
                                  : "#334155",

                              fontWeight:
                                activo
                                  ? 600
                                  : 400,
                            }}
                          >
                            {
                              permiso
                            }
                          </span>
                        </label>
                      );
                    }
                  )}
                </div>
              )}
            </div>
          )
        )
      )}
    </div>
  );
}

export default Permisos;